import ScalarIconPlay_vue_vue_type_script_setup_true_lang_default from "./ScalarIconPlay.vue.script.js";
//#region src/components/ScalarIconPlay.vue
var ScalarIconPlay_default = ScalarIconPlay_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconPlay_default as default };

//# sourceMappingURL=ScalarIconPlay.js.map